<template>
  <Layout>
    <div class="bloco">
      <HeaderPage :pageTitles="pageTitles" />

      <div class="row">
        <div class="col">
          <b-form-group label="Rede">
            <b-form-select>

            </b-form-select>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group label="Loja">
            <b-form-select>

            </b-form-select>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group label="Solicitados por">
            <b-form-select>

            </b-form-select>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group label="Número do Cartão">
            <b-form-input>

            </b-form-input>
          </b-form-group>
        </div>
        <div class="col">
          <b-form-group label="Autorização">
            <b-form-input>

            </b-form-input>
          </b-form-group>
        </div>
        <div class="col">
          <b-button>
            Pesquisar
          </b-button>
        </div>
      </div>

      <div>
        <b-table :items="data" :fields="autorizacaoFields">
          <template #cell(search)="row">
            <b-button variant="outline-primary" size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
              <feather type="search"></feather>
            </b-button>
          </template>
          
          <template #cell(delete)="row">
            <b-button variant="danger" size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
              <feather type="trash-2">></feather>
            </b-button>
          </template>
        </b-table>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'


export default {
  components: { Layout, HeaderPage },
  mixins: [],
  data() {
    return {
      pageTitles: {
        title: 'Cancelar autorização',
        subtitle: 'Cancelar autorizações manuais'
      },
      autorizacaoFields: [
        {
          key: 'data_autorizacao',
          label: 'Data Autorização',
        },
        'Número do Cartão',
        'Valor',
        'Parcelas',
        'Rede',
        'Loja',
        'Autorização',
        'Tipo',
        'Usuário',
        {
          key: 'search',
          label: ''
        },
                {
          key: 'delete',
          label: ''
        },
      ],
      data: [
        {data_autorizacao: '14/01/2022 11:00'},
      ]
    }
  },
  methods: {
    info(a, b, c) {
      console.log(a, b, c)
    }
  },
}
</script>

<style src="../style.scss" lang="scss">
</style>